module.exports = __webpack_public_path__ + "static/yaw-5da7eb21db5313d04f7a0b56b3960d45.gif";